import { useContext, useEffect, useState } from 'react'

import { Avatar } from 'antd'
import { useSelector } from 'react-redux'

import { GlobalContext } from '../../Providers/GlobalProvider'
import { getAssistantProfileImage } from '../../utils/api/assistant'
import { selectUser } from '../../reducers/UserReducer'
import { isAssistant } from '../../utils/roles'

const PATH_ASSETS = '/assets'

const UserProfileImage = () => {
  const { profileImage } = useContext(GlobalContext)

  const user = useSelector(selectUser)

  const [localProfileImage, setLocalProfileImage] = useState(null)
  const [source, setSource] = useState(`${PATH_ASSETS}/default_profile_img.png`)

  console.log(localProfileImage)

  useEffect(() => {
    if (isAssistant(user)) {
      getAssistantProfileImage(user, user.assistant).then(setLocalProfileImage)
    }
  }, [user.id])

  useEffect(() => {
    let src = profileImage || `${PATH_ASSETS}/default_profile_img.png`

    if (localProfileImage !== null) {
      src = localProfileImage || `${PATH_ASSETS}/default_profile_img.png`
    }

    setSource(src)
  }, [profileImage, localProfileImage])

  return (
    <Avatar
      size={60}
      src={source}
    />
  )
}

export default UserProfileImage
